const tables = {
    nameFiller: '[BRAK NAZWY]',
    saveTable: 'ZAPISZ',
};

export default tables;